import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { reportDesignErrorScreen } from 'analytics/reporters';
import { AppRoutes } from 'routes';
import { useCore } from 'contexts/core';
import { DesignSourceEnum } from '@insights/insights-data-provider';
import { useSceneHandler } from 'contexts/sceneHandler';
import { useServices } from 'contexts/services';

const LoadDesignIdFromUrl = ({ match }: any) => {
  const { loadDesignIdScene } = useSceneHandler();
  const { saveService } = useServices();
  const history = useHistory();
  const coreApi = useCore();

  const designId = match.params.designId ?? '';

  useEffect(() => {
    if (designId) {
      loadDesignIdScene(designId, DesignSourceEnum.designSearch, saveService).then(scene =>
        scene?.init()
      );
    } else {
      coreApi.emit.onLoadVpcFailure(undefined);
      reportDesignErrorScreen({ designId: designId });
    }

    history.replace(AppRoutes.PLANNER);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default LoadDesignIdFromUrl;
